import {Box, SvgIcon} from "@mui/material";
import React from "react";

export default function FootwearIcon(props){
  return(
      <img src="/Icons/footwear.svg" alt="footwear" {...props}/>
  )
}